import { Component, Input, inject } from '@angular/core'
import { AppVersionUpdateService } from 'src/app/data/services/application/app-version-update/app-version-update.service'
import { BrandingSize, BrandingVariant } from 'src/app/domain/enums/components/branding.enum'
import { DialogSize } from 'src/app/domain/enums/components/dialog.enum'
import { PrimeIcon } from 'src/app/domain/enums/components/prime-icons.enum'

@Component({ selector: 'app-version-update-screen', templateUrl: './version-update-screen.component.html', styleUrls: ['./version-update-screen.component.scss'] })
export class VersionUpdateScreenComponent {
  private appVersionUpdateService: AppVersionUpdateService = inject(AppVersionUpdateService)

  @Input() isShow: boolean = false

  dialogSize = DialogSize
  brandingVariant = BrandingVariant
  brandingSize = BrandingSize
  primeIcon = PrimeIcon

  callbackReload: Function = () => this.appVersionUpdateService.reload()
}
